import Service from '@ember/service';

import { QueryClient } from '@tanstack/react-query';
import window from 'ember-window-mock';

import ENV from 'register-partners-js/config/environment';

export default class QueryClientManager extends Service {
  queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: ENV.environment !== 'test',
        // default retry is 3: https://tanstack.com/query/latest/docs/framework/react/guides/query-retries
        retry: 0,
      },
    },
  });

  constructor() {
    super(...arguments);

    if (ENV.environment !== 'test') {
      // @ts-expect-error
      window.__TANSTACK_QUERY_CLIENT__ = this.queryClient;
    }
  }

  willDestroy() {
    super.willDestroy();
    this.queryClient.cancelQueries(undefined, { silent: true });
    // eslint-disable-next-line ember/no-array-prototype-extensions -- false positive
    this.queryClient.clear();
  }
}

declare module '@ember/service' {
  interface Registry {
    'query-client-manager': QueryClientManager;
    queryClientManager: QueryClientManager;
  }
}
